import { CustomButton } from '@/shared/ui/components';
import { Modal } from 'antd';
import { FC } from 'react';
import './sessionTimedOutModal.scss';

interface IProps {
  open: boolean;
  loading: boolean;
  handleGotItClick: () => void;
}

const SessionTimedOutModal: FC<IProps> = ({ open, loading, handleGotItClick }) => (
  <Modal
    open={open}
    destroyOnClose
    width={400}
    closable={false}
    maskClosable={false}
    keyboard={false}
    title="Session timed out"
    className="confirm-your-activity-modal"
    footer={null}
  >
    <div className="confirm-your-activity-modal__content">
      You&apos;ve been signed out due to 30 minutes of inactivity. Please sign in again to continue.
    </div>
    <div className="action">
      <CustomButton loading={loading} onClick={handleGotItClick}>
        Got it
      </CustomButton>
    </div>
  </Modal>
);

export default SessionTimedOutModal;
